/**
 * Pro plan — monthly email send limits by contact tier cap.
 * Tier cap = same upper-bound buckets as `PRO_PRICING_TIERS` in stripeConfig.ts.
 * Business plan remains unlimited (handled in subscriptionService).
 */

/** Upper contact caps for Pro pricing, Dodo product map keys, and upgrade UI — keep in sync with `planPricingService` defaults and `functions/dodoPayments.js` tiers. */
export const PRO_TIER_CAPS = [
  1000, 2500, 5000, 8000, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 80000, 100000,
] as const;

const PRO_EMAIL_LIMIT_BY_CAP: Record<number, number> = {
  1000: 12_000,
  2500: 25_000,
  5000: 50_000,
  8000: 80_000,
  10000: 100_000,
  15000: 150_000,
  20000: 200_000,
  25000: 250_000,
  30000: 300_000,
  40000: 400_000,
  50000: 500_000,
  80000: 800_000,
  100000: 1_200_000,
};

/**
 * Monthly email allowance for Pro, based on selected / resolved contact tier cap.
 */
export function getProMonthlyEmailLimit(requestedSubscribers: number): number {
  if (!Number.isFinite(requestedSubscribers) || requestedSubscribers <= 0) {
    return PRO_EMAIL_LIMIT_BY_CAP[1000];
  }
  if (requestedSubscribers < PRO_TIER_CAPS[0]) {
    return PRO_EMAIL_LIMIT_BY_CAP[PRO_TIER_CAPS[0]];
  }
  const cap =
    PRO_TIER_CAPS.find((c) => requestedSubscribers <= c) ??
    PRO_TIER_CAPS[PRO_TIER_CAPS.length - 1];
  return PRO_EMAIL_LIMIT_BY_CAP[cap] ?? PRO_EMAIL_LIMIT_BY_CAP[1000];
}
